import * as tslib_1 from "tslib";
export function reduceResourceEntityExpansions(expansions, action) {
    var _a;
    switch (action.type) {
        case 'INIT':
            return {};
        case 'SET_RESOURCE_ENTITY_EXPANDED':
            return tslib_1.__assign({}, expansions, (_a = {}, _a[action.id] = action.isExpanded, _a));
        default:
            return expansions;
    }
}
